export default __webpack_public_path__ + "static/media/userSearch.6f6256c5.svg";